import axios from "axios";
import { getUrl } from "./common";

const common_axios = axios.create({
  baseURL: getUrl.baseURL,
  // timeout: 30000,
});


common_axios.interceptors.request.use(
  function (config) {
    const token = localStorage.getItem("authToken");
    const programDetail = JSON.parse(localStorage.getItem('programDetail')) ? JSON.parse(localStorage.getItem('programDetail')) : '';
    const uid = localStorage.getItem('uid') ? localStorage.getItem('uid') : '';
    if (token) {
      config.headers["Authorization"] = token;
    }

    config.params = { ...config.params, programId: programDetail.programId, uid: uid }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

// Check your Header    
common_axios.interceptors.response.use(
  function (response) {
    // console.log("succes",response);
    return response;

  },
  function (error) {
    if (error?.response?.status == 404) {
      window.location.href = '/logout';
    }
    if (error?.response?.status == 401) {
      window.location.href = '/logout';
    }
    console.log(error?.response?.status);

  }
);


export default common_axios;